import React, { useState } from "react";
import { Button, Card, Col, Form, Row, Alert, Spinner, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import bg1 from "../assets/img/bg05.jpg";

// Configuration API
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Création du client API
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Intercepteur pour ajouter le token (optionnel, pour les requêtes authentifiées)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default function Signup2() {
  const navigate = useNavigate();
  
  const countries = [
    { name: "Gabon", code: "GA" },
    { name: "Cameroun", code: "CM" },
    { name: "Congo", code: "CG" },
    { name: "Côte d'Ivoire", code: "CI" },
    { name: "Sénégal", code: "SN" },
    { name: "Autre", code: "" }
  ];

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    business_name: "",
    business_country: "",
    business_city: "",
    business_email: "",
    phone: "",
    country_code: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "business_country") {
      const selectedCountry = countries.find(country => country.name === value);
      const countryCode = selectedCountry ? selectedCountry.code : "";
      
      setFormData(prevState => ({
        ...prevState,
        business_country: value,
        country_code: countryCode
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const getPhonePrefix = () => {
    const country = countries.find(c => c.name === formData.business_country);
    if (!country) return "+241";
    
    switch (country.code) {
      case "GA": return "+241";
      case "CM": return "+237";
      case "CG": return "+242";
      case "CI": return "+225";
      case "SN": return "+221";
      default: return "+241";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      // Validation des champs obligatoires
      if (!formData.business_email || !formData.firstname || !formData.lastname) {
        setError("Veuillez remplir les champs obligatoires (*)");
        setLoading(false);
        return;
      }

      // Validation du pays si le code est requis
      if (!formData.country_code && formData.business_country !== "Autre") {
        setError("Veuillez sélectionner un pays valide");
        setLoading(false);
        return;
      }

      // Préparer les données pour l'API
      const submitData = {
        ...formData,
        // Si le pays est "Autre", on envoie une chaîne vide pour country_code
        country_code: formData.business_country === "Autre" ? "" : formData.country_code
      };

      console.log('📤 Envoi inscription:', JSON.stringify(submitData, null, 2));

      // Utilisation de apiClient au lieu de fetch
      const response = await apiClient.post('/register', submitData);

      console.log('📥 Réponse inscription:', JSON.stringify(response.data, null, 2));

      if (response.status === 200 || response.status === 201) {
        const data = response.data;
        
        // Vérifier si le message de succès est présent
        if (data.message || data.success) {
          setSuccess(data.message || data.success || "Inscription réussie !");
          
          // Redirection après succès
          setTimeout(() => {
            navigate('/pages/signin2');
          }, 3000);
        } else {
          setError("Inscription réussie, mais aucune confirmation reçue");
        }
      } else {
        // Gestion des erreurs de l'API
        setError(response.data?.message || "Une erreur est survenue lors de l'inscription");
      }

    } catch (err) {
      // Gestion des erreurs
      console.error('❌ Erreur inscription:', err);
      
      let errorMsg = "Erreur API: ";
      
      if (err.response) {
        // La requête a été faite et le serveur a répondu avec un code d'erreur
        console.error('📌 Détails de l\'erreur:', err.response.data);
        errorMsg = err.response.data?.message || err.response.data?.error || `Erreur ${err.response.status}`;
        
        // Messages d'erreur spécifiques
        if (err.response.status === 409) {
          errorMsg = "Cet email est déjà utilisé. Veuillez vous connecter ou utiliser un autre email.";
        } else if (err.response.status === 422) {
          const validationErrors = err.response.data?.errors;
          if (validationErrors) {
            const firstError = Object.values(validationErrors)[0];
            errorMsg = Array.isArray(firstError) ? firstError[0] : "Erreur de validation";
          } else {
            errorMsg = err.response.data?.message || "Erreur de validation";
          }
        } else if (err.response.status === 429) {
          errorMsg = "Trop de tentatives. Veuillez réessayer plus tard.";
        }
      } else if (err.request) {
        // La requête a été faite mais aucune réponse n'a été reçue
        errorMsg = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
        console.error('📌 Aucune réponse du serveur');
      } else {
        // Erreur lors de la configuration de la requête
        errorMsg = err.message || "Une erreur inattendue s'est produite";
      }
      
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-sign" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
      <Container fluid className="h-100">
        <Row className="">
          {/* Colonne formulaire - Compacte */}
          <Col xl="5" lg="6" md="8" className="py-0">
            <div className="d-flex align-items-center justify-content-center">
              <Card className="card-sign shadow-lg border-0 rounded-4" style={{ maxWidth: "500px", width: "100%" }}>
                <Card.Header className="bg-white border-0 text-center pt-4 pb-2 px-4">
                  <Link
                    to="/"
                    className="header-logo mb-2 fs-4 fw-bold text-primary text-decoration-none"
                  >
                    BULK SMS
                  </Link>
                  <Card.Title className="mb-1 fs-5 fw-semibold text-dark">
                    Créer un compte
                  </Card.Title>
                  <Card.Text className="text-muted small">
                    C'est rapide, gratuit et cela ne prend qu'une minute 🚀
                  </Card.Text>
                </Card.Header>

                <Card.Body className="px-4 pb-3">
                  {/* Alertes compactes */}
                  {error && (
                    <Alert variant="danger" className="mb-2 py-2 small">
                      <i className="ri-error-warning-fill me-1"></i>
                      {error}
                    </Alert>
                  )}

                  {success && (
                    <Alert variant="success" className="mb-2 py-2 small">
                      <i className="ri-checkbox-circle-fill me-1"></i>
                      {success}
                    </Alert>
                  )}

                  <Form onSubmit={handleSubmit} className="px-1">
                    {/* Champs plus compacts */}
                    <Row className="g-2 mb-2">
                      <Col md="6">
                        <Form.Label className="fw-medium small">
                          Prénom <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="firstname"
                          placeholder="Votre prénom"
                          value={formData.firstname}
                          onChange={handleChange}
                          required
                          disabled={loading}
                          size="sm"
                          className="py-2"
                        />
                      </Col>
                      <Col md="6">
                        <Form.Label className="fw-medium small">
                          Nom <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="lastname"
                          placeholder="Votre nom"
                          value={formData.lastname}
                          onChange={handleChange}
                          required
                          disabled={loading}
                          size="sm"
                          className="py-2"
                        />
                      </Col>
                    </Row>

                    <div className="mb-2">
                      <Form.Label className="fw-medium small">Nom de l'entreprise</Form.Label>
                      <Form.Control
                        type="text"
                        name="business_name"
                        placeholder="Nom de votre entreprise"
                        value={formData.business_name}
                        onChange={handleChange}
                        disabled={loading}
                        size="sm"
                        className="py-2"
                      />
                    </div>

                    <div className="mb-2">
                      <Form.Label className="fw-medium small">
                        Email professionnel <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="business_email"
                        placeholder="email@entreprise.com"
                        value={formData.business_email}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        size="sm"
                        className="py-2"
                      />
                    </div>

                    <Row className="g-2 mb-2">
                      <Col md="6">
                        <Form.Label className="fw-medium small">
                          Pays <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="business_country"
                          value={formData.business_country}
                          onChange={handleChange}
                          required
                          disabled={loading}
                          size="sm"
                          className="py-2"
                        >
                          <option value="">Choisissez votre pays</option>
                          {countries.map((country) => (
                            <option key={country.code} value={country.name}>
                              {country.name} {country.code && `(${country.code})`}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md="6">
                        <Form.Label className="fw-medium small">Ville</Form.Label>
                        <Form.Control
                          type="text"
                          name="business_city"
                          placeholder="Votre ville"
                          value={formData.business_city}
                          onChange={handleChange}
                          disabled={loading}
                          size="sm"
                          className="py-2"
                        />
                      </Col>
                    </Row>

                    <div className="mb-3">
                      <Form.Label className="fw-medium small">Numéro de téléphone</Form.Label>
                      <div className="input-group input-group-sm">
                        <Form.Control
                          type="tel"
                          name="phone"
                          placeholder={
                            formData.business_country === "Cameroun" ? "+237XXXXXXXX" :
                            formData.business_country === "Côte d'Ivoire" ? "+225XXXXXXXX" :
                            formData.business_country === "Sénégal" ? "7XXXXXXXX" :
                            formData.business_country === "Congo" ? "+242XXXXXXXX" :
                            "+241XXXXXXXX"
                          }
                          value={formData.phone}
                          onChange={handleChange}
                          disabled={loading}
                          className="border-start-0 py-2"
                        />
                      </div>
                    </div>

                    {/* Bouton principal */}
                    <Button 
                      variant="primary" 
                      type="submit"
                      className="btn-sign w-100 mb-2 py-2 fw-semibold"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Création...
                        </>
                      ) : (
                        "Créer mon compte"
                      )}
                    </Button>
                  </Form>

                  {/* Lien de connexion */}
                  <div className="text-center mt-3 pt-2 border-top">
                    <span className="text-muted small">Vous avez déjà un compte ? </span>
                    <Link to="/" className="fw-semibold text-primary text-decoration-none small">
                      Se connecter
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>

          {/* Colonne image */}
          <Col xl="7" lg="6" className="d-none d-lg-block">
            <div className="h-100 position-relative">
              <img
                src={bg1}
                className="h-100 w-100 object-fit-cover"
                alt="Inscription"
                style={{ minHeight: "70vh" }}
              />
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                <div className="text-center text-white p-4" style={{ background: "rgba(0,0,0,0.5)", borderRadius: "15px" }}>
                  <h2 className="h3 fw-bold mb-3">Rejoignez-nous dès aujourd'hui</h2>
                  <p className="mb-0 small">
                    Gérez vos campagnes SMS en toute simplicité
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .page-sign {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        
        .card-sign {
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }
        
        .btn-sign {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 8px;
          transition: all 0.3s ease;
        }
        
        .btn-sign:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }
        
        .form-control, .form-select {
          border-radius: 6px;
          border: 1px solid #e1e5e9;
          transition: all 0.3s ease;
          font-size: 0.875rem;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
        }
        
        .input-group-text {
          border-radius: 6px 0 0 6px;
          background: #f8f9fa;
          border: 1px solid #e1e5e9;
          font-size: 0.875rem;
        }
        
        @media (max-width: 768px) {
          .card-sign {
            margin: 10px;
            border-radius: 12px;
          }
        }
      `}</style>
    </div>
  );
}